import { Breadcrumb, BreadcrumbProps, Tooltip } from 'antd'
import React, { useRef, useState } from 'react'
import { createPortal } from 'react-dom'

function TruncatedCrumb({ children }: { children: React.ReactNode }) {
    const ref = useRef<HTMLSpanElement>(null)
    const [fullText, setFullText] = useState<string>()

    return (
        <Tooltip title={fullText}>
            <span
                ref={ref}
                className="-mx-1 block max-w-[20rem] truncate px-1 [&_a]:inline"
                onMouseEnter={() => {
                    const element = ref.current
                    setFullText(
                        element && element.scrollWidth > element.clientWidth
                            ? (element.textContent ?? undefined)
                            : undefined
                    )
                }}
            >
                {children}
            </span>
        </Tooltip>
    )
}

export function PortaledBreadcrumb({ items, className, ...props }: BreadcrumbProps) {
    const element = document.getElementById('breadcrumb-portal')
    if (!element) {
        return null
    }

    return (
        <>
            {createPortal(
                <Breadcrumb
                    {...props}
                    className={`[&_ol]:flex-nowrap [&_li]:min-w-0 [&_li]:max-w-max [&_li]:flex-[1_1_0] [&_li]:whitespace-nowrap ${className ?? ''}`}
                    items={items?.map((item) => ({
                        ...item,
                        title: <TruncatedCrumb>{item.title}</TruncatedCrumb>,
                    }))}
                />,
                element
            )}
        </>
    )
}
